var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/**
 * @tdr
 */
export var Wine = function (props) { return (React.createElement("svg", __assign({ width: "16", height: "50" }, props, { viewBox: "0 0 16 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "#333", d: "M5.82 2.293h-.068a.661.661 0 0 0-.658.665v1.33c0 .323.228.592.53.652v5.998C.733 14.734.733 17.402.733 21.525c0 2.845.698 16.849 1.098 24.217 0 .805.08 1.582.517 2.375.44.8 1.275 1.435 2.746 1.435h5.81c1.471 0 2.306-.635 2.746-1.434.437-.794.513-1.571.513-2.376.4-7.368 1.102-21.372 1.102-24.217 0-4.123 0-6.79-4.89-10.587V4.94a.663.663 0 0 0 .53-.652v-1.33a.661.661 0 0 0-.658-.665h-.059c-.024-.057-.053-.105-.078-.15-.051-.087-.092-.157-.072-.232.03-.12.338 0 .338 0v-.797s-.7-.665-2.345-.665h-.064c-1.645 0-2.345.665-2.345.665v.797s.294-.1.338 0c.035.079-.045.215-.109.325l-.032.057Z" }))); };
//# sourceMappingURL=wine.js.map